import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Bookmark, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import DealCard from '../components/DealCard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SavedDeals() {
  const navigate = useNavigate();
  const [savedDeals, setSavedDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSavedDeals = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/deals/saved/details`);
      setSavedDeals(response.data);
    } catch (error) {
      console.error('Error fetching saved deals:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSavedDeals();
  }, []);

  const handleToggleSave = async (dealId) => {
    try {
      await axios.post(`${API}/deals/save/${dealId}`);
      await fetchSavedDeals();
    } catch (error) {
      console.error('Error toggling save:', error);
    }
  };

  return (
    <div className="min-h-screen relative z-10 text-zinc-100">
      <header className="border-b border-zinc-800 bg-zinc-950">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Button 
              data-testid="back-from-saved-btn"
              onClick={() => navigate('/')} 
              className="bg-transparent border border-zinc-700 hover:border-zinc-500 text-zinc-300 font-mono rounded-none"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <h1 className="text-2xl font-mono font-bold uppercase tracking-tight">
              <Bookmark className="inline w-6 h-6 mr-2 mb-1" />
              Saved Deals
            </h1>
            <div className="w-20"></div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-8">
        <div className="mb-6">
          <span className="text-sm font-mono text-zinc-400">{savedDeals.length} Saved Properties</span>
        </div>

        {loading ? (
          <div data-testid="saved-loading-spinner" className="text-center py-20 font-mono text-zinc-500">LOADING...</div>
        ) : savedDeals.length === 0 ? (
          <div data-testid="no-saved-deals-message" className="text-center py-20">
            <Bookmark className="w-16 h-16 mx-auto mb-4 text-zinc-700" />
            <p className="font-mono text-zinc-500">NO SAVED DEALS YET</p>
            <Button 
              onClick={() => navigate('/')} 
              className="mt-6 bg-green-600 hover:bg-green-500 text-black font-mono uppercase tracking-wider rounded-none"
            >
              Browse Deals
            </Button>
          </div>
        ) : (
          <div data-testid="saved-deals-grid" className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {savedDeals.map((deal) => (
              <DealCard 
                key={deal.id} 
                deal={deal} 
                isSaved={true}
                onToggleSave={handleToggleSave}
                onViewDetails={() => navigate(`/deal/${deal.id}`)}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}